// extracted by mini-css-extract-plugin
export default {"image":"ImagePopup_image__ArZhk","close_btn":"ImagePopup_close_btn__3TR8S"};